module.exports = __webpack_public_path__ + "img/acs-full.c9222609.png";